import type { ResolvedMonospaceSpace } from '#layers/data-model/public';
import { useRouter } from '#app/composables/router';
import { useStore } from '#imports';
import { useUpdateSpaceRoutes } from '#layers/spaces/utils/routes';

interface UpdateWorkspaceSpaceRoutesOptions {
	spaces: ResolvedMonospaceSpace[];
	skipCurrentRouteUpdate?: boolean;
}

export function useWorkspaceSpaceRoutes() {
	const store = useStore();
	const router = useRouter();
	const { updateRoutes } = useUpdateSpaceRoutes();

	return {
		loadWorkspaceSpaceRoutes,
		removeWorkspaceSpaceRoutes,
		updateWorkspaceSpaceRoutes,
	};

	async function loadWorkspaceSpaceRoutes() {
		const spaces = await store.MonospaceSpace.findMany({
			include: {
				sections: true,
			},
			fetchPolicy: 'fetch-only',
		});

		await store.MonospacePage.findMany({
			fetchPolicy: 'fetch-only',
		});

		await store.MonospaceBlock.findMany({
			fetchPolicy: 'fetch-only',
		});

		return spaces;
	}

	function updateWorkspaceSpaceRoutes(options: UpdateWorkspaceSpaceRoutesOptions) {
		updateRoutes({
			spaces: options.spaces,
			skipCurrentRouteUpdate: options.skipCurrentRouteUpdate,
		});
	}

	async function removeWorkspaceSpaceRoutes() {
		const previousSpaces = await store.MonospaceSpace.findMany();

		for (const space of previousSpaces) {
			router.removeRoute(space.id);
		}
	}
}
